// @ts-nocheck

import {
  Vue, Options
} from 'vue-class-component'
import Header from '@/components/Header.vue'
import CurrencyInput from '@/components/CurrencyInput.vue'
import CurrencyInputDisable from '@/components/CurrencyInputDisable.vue'
import * as bootstrap from 'bootstrap'
import swal from 'sweetalert'
import { billFactory } from '@/http/bill'
import { masterDataFactory } from '@/http/master-data'
import { userFactory } from '@/http/user'
import roleAccessManager from '@/utils/role-access-manager'

import Utils from '@/utils/utils'
import { setupFactory } from '@/http/setup'

@Options({
  components: {
    Header, CurrencyInput, CurrencyInputDisable
  },
  data () {
    return {
      students: [],
      selectedStudents: {},
      totalBill: 0,
      allSelectedMonth: false,
      monthIds: [],
      selectedClass: [],
      allSelectedClass: false,
      allSelectedClassCross: false,
      classIds: [],
      bills: [],
      school_years: [],
      bill_types: [],
      bill_detail_types: [],
      classes: [],
      months: [],
      crossClasses: [],
      custom_criterias: {},
      custom_criterias_config: [],
      spp_bill_id: null,
      canCreate: false,
      canRead: true,
      canUpdate: false,
      canDelete: false,
      canAccessBillType: false,
      canAccessBillDetailType: false,
      canAccessConvenienceFee: false,
      data: {
        id: '',
        spp_bill_type_id: '',
        school_year_id: '',
        name: '',
        active_date: 1,
        deadline_date: '',
        due_date: '',
        default_total_amount: 0,
        months: [],
        classes: [],
        crossClasses: [],
        details: [],
        custom_criterias: [],
        description: '',
        options: {
          code: null
        },
        fine_rules: {
          value: 0,
          type: 'nominal',
          formula: 'flat',
          daily_percentage: {
            value: 0,
            maximum_days: null,
            accumulative: false
          },
          late_month_fine: {
            value: 0,
            type: 'nominal',
            formula: 'flat'
          }
        },
        user_updated: {
          name: ''
        },
        updated_at: ''
      },
      // showModal: false,
      param: {
        school_year_id: 0
      },
      data_master: {
        school_years: '1',
        classes: '1',
        bill_types: '1',
        bill_detail_types: '1',
        months: '1',
        math_operations: '1',
        custom_criterias: '1'
      },
      classType: 1,
      myModal: [],
      loadingSave: false,
      loadingGenerate: false,
      searchField: '',
      useImportVA: false,
      useCustomCodeBill: false,
      UseLateMonthFine: false,
      sppPromoAnnuallyPaymentPercentage: 0
    }
  },
  methods: {
    save: function () {
      this.loadingSave = true
      const dataClasses = this.data.classes
      const dataCrossClasses = this.data.crossClasses
      if (this.data.crossClasses.length > 0) {
        var classes = dataClasses.concat(dataCrossClasses)
      } else {
        var classes = dataClasses
      }
      const data = {
        id: this.data.id,
        spp_bill_type_id: this.data.spp_bill_type_id,
        school_year_id: this.data.school_year_id,
        name: this.data.name,
        active_date: 1,
        deadline_date: this.data.deadline_date,
        due_date: this.data.due_date,
        default_total_amount: this.data.default_total_amount,
        months: this.data.months,
        classes: classes,
        details: this.data.details,
        custom_criterias: this.data.custom_criterias,
        description: this.data.description,
        options: this.data.options,
        fine_rules: {
          value: this.data.fine_rules.value,
          type: this.data.fine_rules.type,
          formula: this.data.fine_rules.formula,
          daily_percentage: {
            value: this.data.fine_rules.daily_percentage.value,
            maximum_days: this.data.fine_rules.daily_percentage.maximum_days,
            accumulative: this.data.fine_rules.daily_percentage.accumulative
          },
          late_month_fine: {
            value: this.data.fine_rules.late_month_fine.value,
            type: this.data.fine_rules.late_month_fine.type,
            formula: this.data.fine_rules.late_month_fine.formula
          }
        }
      }
      if (this.data.id == '') {
        if (this.useImportVA) {
          data.months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
          data.classes = this.classes.map(function (e: any) { return e.class_id.toString() })
        }

        Promise.resolve(billFactory.createBill(data))
          .then(result => {
            if (result.error == false) {
              swal('Sukses menyimpan tagihan', '', 'success')
              this.hideModal()
              this.loadData()
            } else if (result.response.data.error == true) {
              const errorMessage = result.response.data.messages
              let msg = ''
              for (const i in errorMessage) {
                msg += errorMessage[i] + '<br>'
              }
              const length = 100
              msg = msg.substring(0, length)
              swal({
                text: 'Gagal Menyimpan tagihan',
                icon: 'error',
                content: {
                  element: 'p',
                  attributes: {
                    innerHTML: msg
                  }
                }
              })
            }
          }).catch((e) => {
            swal('Gagal menyimpan tagihan', '', 'error')
            console.log(e)
          }).finally(() => {
            this.loadingSave = false
          })
      } else {
        Promise.resolve(billFactory.updateBill(data.id, data))
          .then(result => {
            if (result.error == false) {
              swal('Sukses menyimpan tagihan', '', 'success')
              this.hideModal()
              this.loadData()
            } else if (result.response.data.error == true) {
              const errorMessage = result.response.data.messages
              let msg = ''
              for (const i in errorMessage) {
                msg += errorMessage[i] + '<br>'
              }
              const length = 100
              msg = msg.substring(0, length)
              swal({
                text: 'Gagal Menyimpan tagihan',
                icon: 'error',
                content: {
                  element: 'p',
                  attributes: {
                    innerHTML: msg
                  }
                }
              })
            }
          }).catch((e) => {
            swal('Gagal menyimpan tagihan', '', 'error')
            console.log(e)
          }).finally(() => {
            this.loadingSave = false
          })
      }
    },
    addDetail: function () {
      this.data.details.push({
        id: '',
        name: '',
        operation: '+',
        default_amount: 0
      })
    },
    removeDetail: function (i: number) {
      this.data.details.splice(i, 1)
    },
    checkAllMonth: function () {
      this.data.months = []

      if (!this.allSelectedMonth) {
        for (const key in this.months) {
          this.data.months.push(key)
        }
      }
    },
    checkAllClass: function (type: any) {
      if (type == 'default') {
        this.data.classes = []
        if (!this.allSelectedClass) {
          this.classes.forEach((c: any) => {
            this.data.classes.push(c.class_id)
          })
        }
      } else {
        this.data.crossClasses = []
        if (!this.allSelectedClassCross) {
          this.crossClasses.forEach((c: any) => {
            this.data.crossClasses.push(c.class_id)
          })
        }
      }
    },
    calculatePrice: function () {
      this.data.default_total_amount = 0
      this.data.details.forEach((bill: any) => {
        if (bill.operation == '-') {
          this.data.default_total_amount -= parseInt(bill.default_amount)
        } else {
          this.data.default_total_amount += parseInt(bill.default_amount)
        }
      })
    },
    getMonthByID: function (id: any) {
      if (id != '') {
        return this.months[id].id
      }
    },
    edit: function (id: any) {
      Promise.resolve(billFactory.billDetail(id))
        .then(result => {
          if (result != false) {
            const bill = result.data.bill
            const data = {
              id: bill.id,
              spp_bill_type_id: bill.spp_bill_type_id,
              school_year_id: bill.school_year_id,
              name: bill.name,
              active_date: bill.active_date,
              deadline_date: bill.deadline_date,
              due_date: bill.due_date,
              default_total_amount: bill.default_total_amount,
              months: bill.months,
              details: bill.details,
              custom_criterias: bill.custom_criterias || [],
              description: bill.description,
              options: bill.options,
              fine_rules: {
                value: bill.fine_rules.value,
                type: bill.fine_rules.type,
                formula: bill.fine_rules.formula,
                daily_percentage: {
                  value: bill.fine_rules.daily_percentage?.value || 0,
                  maximum_days: bill.fine_rules.daily_percentage?.maximum_days || null,
                  accumulative: bill.fine_rules.daily_percentage?.accumulative || false
                },
                late_month_fine: {
                  value: bill.fine_rules.late_month_fine.value,
                  type: bill.fine_rules.late_month_fine.type,
                  formula: bill.fine_rules.late_month_fine.formula
                }
              },
              class_type: bill.class_type,
              user_updated: bill.user_updated,
              updated_at: Utils.beautifyDatetime(bill.updated_at)
            }

            // if data.options.code not exist, set it to null
            if (data.options == null) {
              data.options = {
                code: null
              }
            }

            this.data = data
            this.data.classes = []
            this.data.crossClasses = []
            const classes = this.classes.map(function (e: any) { return e.class_id.toString() })
            const crossClasses = this.crossClasses.map(function (e: any) { return e.class_id.toString() })
            bill.classes.forEach((c: any) => {
              if (crossClasses.indexOf(c) > -1) {
                this.data.crossClasses.push(c)
              } else if (classes.indexOf(c) > -1) {
                this.data.classes.push(c)
              }
            })
            this.allSelectedClass = false
            this.allSelectedMonth = false
            this.allSelectedClassCross = false
            this.classType = 1
            this.calculatePrice()
          } else {
            swal('Gagal melakukan request', '', 'error')
          }
        }).catch((e) => {
          swal('Gagal melakukan request', '', 'error')
          console.log(e)
        })
    },
    add: function () {
      this.allSelectedClass = false
      this.allSelectedMonth = false
      this.allSelectedClassCross = false
      this.classType = 1
      this.data.id = ''
      this.data.spp_bill_type_id = ''
      this.data.school_year_id = ''
      this.data.name = ''
      this.data.active_date = 1
      this.data.deadline_date = ''
      this.data.due_date = ''
      this.data.default_total_amount = 0
      this.data.months = []
      this.data.classes = []
      this.data.crossClasses = []
      this.data.details = [{
        id: '',
        spp_bill_detail_type_id: null,
        operation: '+',
        default_amount: 0
      }]
      this.data.custom_criterias = []
      this.data.description = ''
      this.data.options = {
        code: null
      }
      this.data.fine_rules = {
        value: 0,
        type: 'nominal',
        formula: 'flat',
        daily_percentage: {
          value: 0,
          maximum_days: null,
          accumulative: false
        },
        late_month_fine: {
          value: 0,
          type: 'nominal',
          formula: 'flat'
        }
      }
      this.data.class_type = ''
    },
    generate: function () {
      this.loadingGenerate = true
      swal({
        title: 'Apakah anda yakin?',
        text: 'Generate tagihan hanya akan menghasilkan tagihan ke siswa yang belum terbuat tagihannya, tagihan yang sudah ada tidak diduplikasi atau terubah datanya.',
        icon: 'warning',
        buttons: {
          cancel: true,
          confirm: true
        },
        dangerMode: true
      })
        .then((willGenerate) => {
          if (willGenerate) {
            if (this.data.id != '') {
              Promise.resolve(billFactory.generateBill(this.data.id))
                .then(result => {
                  if (result.error == false) {
                    const num_bill_user = result.data.num_bill_user
                    swal('Sukses menghasilkan tagihan ke ' + num_bill_user + ' siswa', '', 'success')
                    this.hideModal()
                    this.loadData()
                  } else if (result.response.data.error == true) {
                    const errorMessage = result.response.data.messages
                    let msg = ''
                    for (const i in errorMessage) {
                      msg += errorMessage[i] + '<br>'
                    }
                    const length = 100
                    msg = msg.substring(0, length)
                    swal({
                      text: 'Gagal menghasilkan tagihan ke siswa',
                      icon: 'error',
                      content: {
                        element: 'p',
                        attributes: {
                          innerHTML: msg
                        }
                      }
                    })
                  }
                }).catch((e) => {
                  swal('Gagal menghasilkan tagihan ke tiap siswa', '', 'error')
                  console.log(e)
                }).finally(() => {
                  this.loadingGenerate = false
                })
            } else {
              swal('Gagal menghasilkan tagihan ke tiap siswa', '', 'error')
              this.loadingGenerate = false
            }
          } else {
            swal('Batal generate tagihan!')
            this.loadingGenerate = false
          }
        })
    },
    generateByStudentIDs: function () {
      this.loadingGenerate = true
      swal({
        title: 'Apakah anda yakin?',
        text: 'Generate tagihan hanya akan menghasilkan tagihan ke siswa yang belum terbuat tagihannya, tagihan yang sudah ada tidak diduplikasi atau terubah datanya.',
        icon: 'warning',
        buttons: {
          cancel: true,
          confirm: true
        },
        dangerMode: true
      }).then((willGenerate) => {
        if (!willGenerate) {
          swal('Batal generate tagihan!')
          this.loadingGenerate = false
          return false
        }

        if (!this.spp_bill_id) {
          swal('Harap pilih tagihan terlebih dulu', '', 'error')
          this.loadingGenerate = false
          return false
        }

        const student_ids = Object.keys(this.selectedStudents)
        if (student_ids.length < 1) {
          swal('Harap pilih dulu minimal satu siswa', '', 'error')
          this.loadingGenerate = false
          return false
        }

        Promise.resolve(billFactory.generateBillByUserIds(this.spp_bill_id, student_ids))
          .then(result => {
            if (result.error == false) {
              const num_bill_user = result.data.num_bill_user
              swal('Sukses menghasilkan ' + num_bill_user + ' tagihan', '', 'success')
              this.hideModal()
              this.loadData()
            } else if (result.response.data.error == true) {
              const errorMessage = result.response.data.messages
              let msg = ''
              for (const i in errorMessage) {
                msg += errorMessage[i] + '<br>'
              }
              const length = 100
              msg = msg.substring(0, length)
              swal({
                text: 'Gagal menghasilkan tagihan ke siswa',
                icon: 'error',
                content: {
                  element: 'p',
                  attributes: {
                    innerHTML: msg
                  }
                }
              })
            }
          }).catch((e) => {
            swal('Gagal menghasilkan tagihan ke tiap siswa', '', 'error')
            console.log(e)
          }).finally(() => {
            this.loadingGenerate = false
          })
      })
    },
    loadData: function () {
      Promise.resolve(billFactory.bill(this.param))
        .then(result => {
          this.bills = result.data.bills
        })
    },
    loadDataMaster: function () {
      // console.log(this.data_master)
      Promise.resolve(masterDataFactory.master_datas(this.data_master))
        .then(result => {
          this.school_years = result.data.school_years
          const classes = result.data.classes
          const billTypes = result.data.bill_types
          billTypes.forEach((type: any, _: any, __: any) => {
            if (type.status == 1) {
              this.bill_types.push(type)
            }
          })
          this.bill_detail_types = result.data.bill_detail_types
          this.months = result.data.months
          this.math_operations = result.data.math_operations
          this.custom_criterias = result.data.custom_criterias || {}
          this.custom_criterias_config = result.data.custom_criterias_config || []
          this.school_years.forEach((school_year: any) => {
            if (school_year.status == 'Active') {
              this.param.school_year_id = school_year.school_year_id
            }
          })
          classes.forEach((c: any) => {
            if (c.class_type_id == 4) {
              this.crossClasses.push(c)
            } else {
              this.classes.push(c)
            }
          })
          this.loadData()
        })
    },
    showModal: function () {
      this.myModal.show()
    },
    hideModal: function () {
      this.myModal.hide()
    },
    setBillDetailType: function (value: string, i: any) {
      this.bill_detail_types.forEach((type: any) => {
        if (value == type.id) {
          this.data.details[i].operation = type.operation
          this.data.details[i].name = type.name
        }
      })
    },
    async getSuggestions () {
      if (this.searchField.length > 3) {
        const param = {
          keyword: this.searchField
        }
        Promise.resolve(userFactory.students(param))
          .then(result => {
            const users = result.data.users[0]
            const students: any = []
            users.forEach((value: any) => {
              if (value.child_name == null) {
                students.push({
                  child_name: value.name,
                  child_user_id: value.user_id
                })
              } else {
                students.push(value)
              }
            })
            this.students = students
          }).catch((e) => {
            swal('Gagal melakukan request', '', 'error')
            console.log(e)
            this.students = []
          })
      } else {
        this.students = []
      }
    },
    addToSelectedStudent (student: any) {
      this.selectedStudents[student.child_user_id] = student
    },
    removeSelectedStudent (student_id: number) {
      delete this.selectedStudents[student_id]
    },
    isCriteriaSelected (name: string, value: any) {
      if (!this.data.custom_criterias) return false
      return this.data.custom_criterias.some((c: any) => c[name] == value)
    },
    toggleCriteria (name: string, value: any, checked: boolean) {
      if (!this.data.custom_criterias) this.data.custom_criterias = []

      if (checked) {
        const obj: any = {}
        obj[name] = value
        this.data.custom_criterias.push(obj)
      } else {
        this.data.custom_criterias = this.data.custom_criterias.filter((c: any) => c[name] != value)
      }
    }
  },
  computed: {
    config () {
      return {
        currency: 'IDR',
        precision: 0,
        distractionFree: false,
        valueAsInteger: true
      }
    }
  },
  async mounted () {
    // Check role access for /bill
    if (!roleAccessManager.canRead('/bill')) {
      swal({
        title: 'Access Denied',
        text: 'Anda tidak memiliki akses ke halaman Master Tagihan',
        icon: 'error'
      }).then(() => {
        this.$router.push('/loginpage')
      })
      return
    }

    // Set permission flags
    this.canCreate = roleAccessManager.canCreate('/bill')
    this.canRead = roleAccessManager.canRead('/bill')
    this.canUpdate = roleAccessManager.canUpdate('/bill')
    this.canDelete = roleAccessManager.canDelete('/bill')
    
    // Check access to related paths
    this.canAccessBillType = roleAccessManager.canRead('/bill/type')
    this.canAccessBillDetailType = roleAccessManager.canRead('/bill_detail/type')
    this.canAccessConvenienceFee = roleAccessManager.canRead('/convenience/fee')

    const myModal = document.getElementById('billModal')
    if (myModal != null) {
      this.myModal = new bootstrap.Modal(myModal)
    }

    Promise.resolve(setupFactory.getFeatureConfigs({ feature_configs: ['spp_show_US_import_VA', 'spp_promo_annually_payment_percentage', 'spp_use_late_month_fine', 'spp_use_custom_code_bill'] })).then(
      (res) => {
        this.useImportVA = ('spp_show_US_import_VA' in res.data.feature_configs && res.data.feature_configs.spp_show_US_import_VA && res.data.feature_configs.spp_show_US_import_VA == 'true')
        this.useCustomCodeBill = ('spp_use_custom_code_bill' in res.data.feature_configs && res.data.feature_configs.spp_use_custom_code_bill && res.data.feature_configs.spp_use_custom_code_bill == 'true')
        this.UseLateMonthFine = ('spp_use_late_month_fine' in res.data.feature_configs && res.data.feature_configs.spp_use_late_month_fine && res.data.feature_configs.spp_use_late_month_fine == 'true')
        if ('spp_promo_annually_payment_percentage' in res.data.feature_configs) {
          this.sppPromoAnnuallyPaymentPercentage = parseInt(res.data.feature_configs.spp_promo_annually_payment_percentage)
        }
      }
    )

    await this.loadDataMaster()
  }
})

export default class Bill extends Vue {}